export default __webpack_public_path__ + "static/media/touch_app.f786ca8d.svg";